import { ITranslations } from 'types/common';
import { ProductsTransFields } from './types';
import en from 'translations/en/products.json';
import pl from 'translations/pl/products.json';
import sl from 'translations/sl/products.json';

export const productsTranslations: ITranslations<ProductsTransFields> = {
  name: 'products',
  en,
  pl,
  sl,
};
